import { IProductSettings } from './product-settings-interfaces';

import { routingConstants } from 'app/shared/constants/routing.const';
import { pipelineRunAnchorIds } from 'app/tour/pipelinerun-tour-steps';
import { connectionAnchorIds } from 'app/tour/connection-tour-steps';
import { StaticLocaleRecord } from 'app/utils/localization';

export const adfProductSettings: IProductSettings = new StaticLocaleRecord<IProductSettings>(() => ({
    clientId: '16f9b8e9-d20b-45a1-ab9e-db2e8254508b',
    productInfo: {
        name: 'adf',
        image: 'svg-dataFactory'
    },
    layoutConfiguration: {
        headerTitle: stringResources.DataFactory,
        appTitle: 'Azure Data Factory',
        predefinedNavigationBar: [
            {
                id: 'home',
                title: stringResources.Home,
                module: 'home',
                navigationPath: routingConstants.overviewPath,
                selected: false,
                order: 0,
                iconDetail: {
                    iconType: 'class',
                    iconInfo: 'icon svg-overview-icon'
                }
            },
            {
                id: 'authoring',
                title: stringResources.AuthorTooltip,
                module: 'authoring',
                navigationPath: routingConstants.authoringPath,
                selected: false,
                order: 10,
                iconDetail: {
                    iconType: 'class',
                    iconInfo: 'icon svg-authoring-icon adfNavIcon'
                },
                views: [
                    {
                        id: 'pipeline',
                        order: 0,
                        name: stringResources.Pipelines
                    },
                    {
                        id: 'dataset',
                        order: 10,
                        name: stringResources.ModelName_DataSets
                    },
                    {
                        id: 'dataflow',
                        name: stringResources.DataFlows,
                        order: 30
                    },
                    {
                        id: 'powerquery',
                        name: stringResources.PowerQuery,
                        order: 50
                    },
                    {
                        id: 'template',
                        name: stringResources.ModelName_Templates,
                        order: 80
                    },
                    {
                        id: 'airflowEntity',
                        order: 90,
                        name: stringResources.AirflowEntity
                    }
                ]
            },
            {
                id: 'monitoring',
                title: stringResources.Monitor,
                module: 'monitoring',
                navigationPath: routingConstants.monitoringPath,
                guidedTourMessage: stringResources.Tour_LeftNavigation_Monitor,
                selected: false,
                order: 30,
                iconDetail: {
                    iconType: 'class',
                    iconInfo: 'icon svg-monitoring-icon adfNavIcon'
                },
                viewGroups: [
                    {
                        id: 'general',
                        name: ''
                    },
                    {
                        id: 'runsGroup',
                        name: stringResources.Monioring_ViewRunsLabel
                    },
                    {
                        id: 'runtimesGroup',
                        name: stringResources.Monitoring_RuntimeLabel
                    },
                    {
                        id: 'notifyGroup',
                        name: stringResources.Notifications
                    }
                ],
                views: [
                    {
                        id: routingConstants.adfMonitoringDashboard,
                        name: stringResources.Dashboard,
                        groupId: 'general',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-size-16 icon-dashboard'
                        },
                        order: 0
                    },
                    {
                        id: routingConstants.pipelineRuns,
                        name: stringResources.PipelineRunsLabel,
                        groupId: 'runsGroup',
                        appTourId: pipelineRunAnchorIds.MonitorIcon,
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-size-16 icon-pipelinerun'
                        },
                        order: 1
                    },
                    {
                        id: routingConstants.triggerRuns,
                        name: stringResources.TriggerRunsLabel,
                        groupId: 'runsGroup',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-triggerrun icon-size-16'
                        },
                        order: 2
                    },
                    {
                        id: routingConstants.integrationRuntimes,
                        name: stringResources.IntegrationRuntimes,
                        groupId: 'runtimesGroup',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i-20x20-integrationruntime'
                        },
                        order: 3
                    },
                    {
                        id: routingConstants.dataflowDebug,
                        name: stringResources.DataFlowDebug,
                        groupId: 'runtimesGroup',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-size-16 icon-i-20x20-MappingDF-Monochrome'
                        },
                        order: 4
                    },
                    {
                        id: routingConstants.alerts,
                        name: stringResources.Monitoring_AlertsAndMertrics,
                        groupId: 'notifyGroup',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-size-16 icon-alert'
                        },
                        order: 5
                    }
                ]
            },
            {
                id: 'management',
                title: stringResources.Manage,
                module: 'management',
                navigationPath: routingConstants.managementPath,
                guidedTourMessage: stringResources.Tour_LeftNavigation_Management,
                selected: false,
                order: 50,
                iconDetail: {
                    iconType: 'class',
                    iconInfo: 'icon svg-management-icon adfNavIcon'
                },
                viewGroups: [
                    {
                        id: 'general',
                        name: stringResources.General
                    },
                    {
                        id: 'connections',
                        name: stringResources.Connections
                    },
                    {
                        id: 'git',
                        name: stringResources.SourceControl
                    },
                    {
                        id: 'parameters',
                        name: stringResources.GlobalParametersLabel
                    },
                    {
                        id: 'author',
                        name: stringResources.AuthorTooltip
                    },
                    {
                        id: 'security',
                        name: stringResources.Security
                    },
                    {
                        id: 'airflow',
                        name: stringResources.WorkflowOrchestrationManager
                    }
                ],
                views: [
                    {
                        id: routingConstants.upgrades,
                        name: stringResources.Upgrades_Label,
                        groupId: 'general',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-upgradeproduct icon-size-18'
                        }
                    },
                    {
                        id: routingConstants.dataLinkedServices,
                        name: stringResources.LinkedServices,
                        groupId: 'connections',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i_linkedservice_black_16x16'
                        }
                    },
                    {
                        id: routingConstants.integrationRuntimes,
                        name: stringResources.IntegrationRuntimes,
                        appTourId: connectionAnchorIds.IRTab,
                        groupId: 'connections',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i-20x20-integrationruntime'
                        }
                    },
                    // {
                    //     id: routingConstants.babylon,
                    //     name: stringResources.Babylon,
                    //     groupId: 'connections',
                    //     iconDetail: {
                    //         iconType: 'class',
                    //         iconInfo: 'svg-i_linkedservice_black_16x16'
                    //     }
                    // },
                    {
                        id: routingConstants.triggers,
                        name: stringResources.Triggers,
                        groupId: 'author',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-trigger icon-size icon-color'
                        }
                    },
                    {
                        id: routingConstants.globalparameters,
                        name: stringResources.GlobalParametersLabel,
                        groupId: 'author',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i-20x20-globalparameters'
                        }
                    },
                    {
                        id: routingConstants.userdefinedfunctions,
                        name: stringResources.UDFLibraries,
                        groupId: 'author',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i_DataFlowLibraries_16x'
                        }
                    },
                    {
                        id: routingConstants.git,
                        name: stringResources.GitConfiguration,
                        groupId: 'git',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i-16x16-sourcecontrol-black'
                        }
                    },
                    {
                        id: routingConstants.credentialList,
                        name: stringResources.AuthenticationType_UseCredentials,
                        groupId: 'security',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'madrid-icon icon-credentials icon-size-16'
                        }
                    },
                    {
                        id: routingConstants.armtemplate,
                        name: stringResources.ARMTemplate,
                        groupId: 'git',
                        iconDetail: {
                            iconType: 'class',
                            iconInfo: 'svg-i-16x16-arm'
                        }
                    }
                ]
            },
            {
                id: 'learn',
                title: stringResources.LearningCenter,
                module: 'learn',
                navigationPath: routingConstants.learnPath,
                selected: false,
                order: 100,
                iconDetail: {
                    iconType: 'class',
                    iconInfo: 'icon svg-knowledge-center'
                }
            }
        ]
    }
})).value;


